import { useAppSelector, useAppDispatch } from "@/store/hooks";
import { setAgentSlug, setSelectedAgent } from "@/store/agentsSlice";
import { clearConversationId } from "@/store/conversationsSlice";
import { useNavigate } from "react-router-dom";

export function SidebarAgentsList() {
  const agents = useAppSelector((s) => s.agents.agents);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <div className="ml-4 mt-1 space-y-1">
      {agents.slice(0, 5).map((agent) => (
        <button
          key={agent.agentId}
          className="w-full text-left px-3 py-2 rounded-md text-sm hover:bg-accent transition-colors cursor-pointer"
          onClick={() => {
            dispatch(setAgentSlug(agent.agentId));
            dispatch(setSelectedAgent(agent));
            dispatch(clearConversationId()); // Clear conversation ID when navigating to agent
            navigate(`/agent/${agent.agentId}`);
          }}
        >
          <div className="truncate">{agent.agentName}</div>
          <div className="text-xs text-muted-foreground mt-0.5">{agent.persona}</div>
        </button>
      ))}
      <button
        className="w-full text-left px-3 py-2 rounded-md text-sm text-primary cursor-pointer hover:bg-accent/50 font-medium"
        onClick={() => navigate("/agents")}
      >
        View all
      </button>
    </div>
  );
}
